export default __webpack_public_path__ + "static/media/eigenheim_icons_clock.27e4bf3b.svg";